export default __webpack_public_path__ + "static/media/whiteShirt.76fd0e42.png";